import { AppShell, Container, Paper } from "@mantine/core";
import { useContext, type FC, type PropsWithChildren } from "react";

import NoticeBanners from "src/components/notices/NoticeBanners";
import LayoutContext from "src/contexts/layouts/LayoutContext";

import LayoutContent from "../shared/LayoutContent";
import LayoutFooter from "../shared/LayoutFooter";
import LazySearch from "../shared/LazySearch";
import Header from "./Header";
import NavMenu from "./NavMenu";
import SubMenus from "./SubMenus";

/**
 * Composes the legacy-style header, menus, notice banners and page content.
 *
 * Postconditions: Menu collections come from layout context; shared content controls page access
 * presentation. Search and footer remain mounted in their existing positions.
 */
const DefaultLayout: FC<PropsWithChildren> = ({ children }) => {
    const layoutContext = useContext(LayoutContext);

    return (
        <AppShell
            mode="static"
            header={{ height: "auto" }}
            padding={0}
            withBorder={false}
        >
            <AppShell.Header>
                <Header />
                <NavMenu menuItems={layoutContext.menuItems} />
                <SubMenus subMenus={layoutContext.subMenus} />
            </AppShell.Header>
            <AppShell.Main>
                <NoticeBanners />
                <Container size="xl">
                    <Paper
                        withBorder
                        radius={0}
                        p="sm"
                        mb="sm"
                    >
                        <LayoutContent>{children}</LayoutContent>
                        <LayoutFooter />
                    </Paper>
                </Container>
                <LazySearch />
            </AppShell.Main>
        </AppShell>
    );
};

export default DefaultLayout;
